import { useQuery } from "react-query";
import { useIntl } from "react-intl";

import {
  ListRequestOfBaseFilter,
  ListResponseOfProfession,
  Profession,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectProfessionProps = Omit<
  AutocompleteWithQueryProps<Profession>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectProfession = (props: SelectProfessionProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchedProfessions = useQuery<ListResponseOfProfession>(
    ["professions"],
    () =>
      skuService.getProfessions(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedProfessions}
      failMessage={t({ id: "selectProfessionFailed" })}
    />
  );
};

export default SelectProfession;
